import { size, __spreadValues } from './chunk-JJ6VZ5V7.mjs';
import * as React from 'react';
import styled, { color } from '@xstyled/styled-components';

var SvgComponent = (props) => /* @__PURE__ */ React.createElement(
  "svg",
  __spreadValues({
    xmlns: "http://www.w3.org/2000/svg",
    width: "24px",
    height: "24px",
    fill: "none",
    "aria-hidden": "true",
    viewBox: "0 0 24 24"
  }, props),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "currentColor",
      d: "M12 2a1 1 0 1 1 0 2 8 8 0 0 0-3.552.832l-.22.112a8 8 0 0 0-2.74 2.409l-.14.203a8 8 0 0 0-1.282 3.415l-.028.245a8 8 0 0 0 .571 3.846l.098.226a8 8 0 0 0 2.218 2.897l.193.153a8 8 0 0 0 3.321 1.509l.242.044a8 8 0 0 0 3.641-.236l.235-.075a8 8 0 0 0 3.1-1.923 1 1 0 1 1 1.414 1.414 10 10 0 0 1-3.875 2.405l-.293.093a10 10 0 0 1-4.55.294l-.304-.055a10 10 0 0 1-4.152-1.886l-.24-.192a10 10 0 0 1-2.773-3.62l-.123-.283a10 10 0 0 1-.713-4.807l.035-.306a10 10 0 0 1 1.602-4.27l.175-.254a10 10 0 0 1 3.426-3.01l.273-.14A10 10 0 0 1 12 2"
    }
  ),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "currentColor",
      d: "M18.706 5.902a4.12 4.12 0 0 1-2.608-2.609.103.103 0 0 0-.196 0 4.12 4.12 0 0 1-2.609 2.61.103.103 0 0 0 0 .195 4.12 4.12 0 0 1 2.609 2.609.103.103 0 0 0 .196 0 4.12 4.12 0 0 1 2.608-2.61.103.103 0 0 0 0-.195m-3.902 8.033a2.75 2.75 0 0 1-1.739-1.74.069.069 0 0 0-.13 0 2.75 2.75 0 0 1-1.74 1.74.069.069 0 0 0 0 .13 2.75 2.75 0 0 1 1.74 1.74c.02.062.11.062.13 0a2.75 2.75 0 0 1 1.74-1.74.069.069 0 0 0 0-.13m7.804-2.065a5.5 5.5 0 0 1-3.479-3.48.138.138 0 0 0-.26 0 5.5 5.5 0 0 1-3.479 3.479.137.137 0 0 0 0 .26 5.5 5.5 0 0 1 3.478 3.479c.042.125.22.125.261 0a5.5 5.5 0 0 1 3.479-3.479.137.137 0 0 0 0-.26"
    }
  )
);
var SvgAiAssistProFilled = styled(SvgComponent)`
  ${size}
  ${color}
`;
var AiAssistProFilled_default = SvgAiAssistProFilled;

export { AiAssistProFilled_default as default };
